export default "../css/68544d4e17f6846976ced354047b84e9.ttf";